import { GALLERY_SCHEMA } from "../../consts/Template";

const Unstyled = {
  [GALLERY_SCHEMA.ID]: "unstyled",
  [GALLERY_SCHEMA.NAME]: "Unstyled",
  [GALLERY_SCHEMA.CATEGORY]: null,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
    </mj-style>
    <mj-attributes>
      <mj-all padding="0px" />
    </mj-attributes>
  </mj-head>
  <mj-body width="100%" background-color="transparent">
    <mj-section
      padding="0px"
      background-color="transparent"
      full-width="full-width">
      <mj-column padding="0px">
        <mj-text
          padding="0px"
          font-family="Arial, sans-serif"
          line-height="1.5">
          <p>Lorem ipsum,</p>

<p><br></p>

<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>

<p><br></p>

<p><strong>Duis Aute Irure Dolor</strong></p>

<p><br></p>

<p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

<p><br></p>

<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>

<p><br></p>

<p><strong>Nemo Enim Ipsam</strong></p>

<p><br></p>

<p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit:</p>

<p><br></p>

<p>1. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet<br>
2. Consectetur adipisci velit, sed quia non numquam eius modi<br>
3. Tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem</p>

<p><br></p>

<p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>

<p><br></p>

<p>Similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</p>

<p><br></p>

<p><strong>Temporibus Autem</strong></p>

<p><br></p>

<p>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>

<p><br></p>

<p>Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae.</p>

<p><br></p>

<p>Lorem ipsum dolor sit amet.</p>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    p { display: block; margin: 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
  </style>
</head>
<body style="word-spacing:normal;background-color:transparent;">
  <div style="background-color:transparent;">
    <div style="margin:0px auto;width:100%;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial, sans-serif;font-size:13px;line-height:1.5;text-align:left;color:#000000;">
                          <p>Lorem ipsum,</p>

<p>&nbsp;</p>

<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>

<p>&nbsp;</p>

<p><strong>Duis Aute Irure Dolor</strong></p>

<p>&nbsp;</p>

<p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

<p>&nbsp;</p>

<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>

<p>&nbsp;</p>

<p><strong>Nemo Enim Ipsam</strong></p>

<p>&nbsp;</p>

<p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit:</p>

<p>&nbsp;</p>

<p>1. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet<br>
2. Consectetur adipisci velit, sed quia non numquam eius modi<br>
3. Tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem</p>

<p>&nbsp;</p>

<p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>
</html>`,
};
export default Unstyled;
